import { requestQuery } from '@/services/request';
import { coreAutoSuggest } from '@/modules/search/domain/routes/searchRoutes';

export const getAutoSuggests = (search: string) =>
  requestQuery<string[]>({
    url: coreAutoSuggest,
    params: {
      q: search,
    },
  });
